/**
 * Client-side navigation helper — the ONE implementation of SPA navigation
 * used by the storage note on the dashboard, the settings modal's “Full
 * page” link, the /settings page header and deep links. pushState + a
 * synthetic popstate (the useRoute router listens for popstate) keeps the
 * SPA alive instead of forcing a full document reload.
 */
export function navigate(to: string): void {
  if (window.location.pathname === to) return;
  history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo(0, 0);
}
